import { useState, useEffect } from "react"

const WINDOW_NAME = "lista_espera_window"
const WINDOW_URL = "/fullscreen/lista-espera"
const STORAGE_KEY = "listaEsperaAbierta"

export function useListaEsperaView() {
    const [windowRef, setWindowRef] = useState<Window | null>(null)
    const [isOpen, setIsOpen] = useState(() => {
        return localStorage.getItem(STORAGE_KEY) === "true"
    })

    const openWindow = () => {
        if (windowRef && !windowRef.closed) {
            windowRef.focus()
            return
        }

        const win = window.open(WINDOW_URL, WINDOW_NAME)
        if (win) {
            setWindowRef(win)
            setIsOpen(true)
            localStorage.setItem(STORAGE_KEY, "true")
            win.focus()
        }
    }

    useEffect(() => {
        if (localStorage.getItem(STORAGE_KEY) === "true") {
            const existing = window.open("", WINDOW_NAME)
            if (existing && !existing.closed) {
                setWindowRef(existing)
                setIsOpen(true)
            } else {
                localStorage.removeItem(STORAGE_KEY)
                setIsOpen(false)
            }
        }
    }, [])

    useEffect(() => {
        if (!windowRef) return
        const interval = setInterval(() => {
            if (windowRef.closed) {
                setIsOpen(false)
                setWindowRef(null)
                localStorage.removeItem(STORAGE_KEY)
                clearInterval(interval)
            }
        }, 500)
        return () => clearInterval(interval)
    }, [windowRef])
    
    useEffect(() => {
        const handleStorage = (event: StorageEvent) => {
            if (event.key === STORAGE_KEY) {
                setIsOpen(event.newValue === "true")
            }
        }
        window.addEventListener("storage", handleStorage)
        return () => window.removeEventListener("storage", handleStorage)
    }, [])

    return { isOpen, openWindow }
}
